export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-shape/src/array.js
// module id = 170
// module chunks = 0